import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m13.09 6.72.31-3.11a11.5 11.5 0 0 1 3.2 0l.31 3.11a8.5 8.5 0 0 1 2.59 1.07h0l2.42-1.97a11.5 11.5 0 0 1 2.26 2.26l-1.97 2.42a8.5 8.5 0 0 1 1.07 2.59h0l3.11.31a11.5 11.5 0 0 1 0 3.2l-3.11.31a8.5 8.5 0 0 1-1.07 2.59h0l1.97 2.42a11.5 11.5 0 0 1-2.26 2.26l-2.42-1.97a8.5 8.5 0 0 1-2.59 1.07h0l-.31 3.11a11.5 11.5 0 0 1-3.2 0l-.31-3.11a8.5 8.5 0 0 1-2.59-1.07h0l-2.42 1.97a11.5 11.5 0 0 1-2.26-2.26l1.97-2.42a8.5 8.5 0 0 1-1.07-2.59h0l-3.11-.31a11.5 11.5 0 0 1 0-3.2l3.11-.31a8.5 8.5 0 0 1 1.07-2.59h0L5.82 8.08a11.5 11.5 0 0 1 2.26-2.26l2.42 1.97a8.5 8.5 0 0 1 2.59-1.07" }, null, -1 /* CACHED */),
    _createElementVNode("circle", {
      cx: "15",
      cy: "15",
      r: "3.5"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }